import React, { useState, useRef } from 'react';

import './PartnerList.scss';
import icons from '../../shared/assets/icons';
import sendEvent from '../../helpers/tracking';
import { useMobile } from '../../helpers/hooks';

const { LeftArrow, RightArrow } = icons;

export default function PartnerList(props) {
  const { topList, bottomList } = props.list.reduce(
    (obj, item, idx) => {
      if (idx % 2 === 0) obj.topList.push(item);
      else obj.bottomList.push(item);

      return obj;
    },
    { topList: [], bottomList: [] }
  );

  const list = useRef(null);
  const [isMobile, setIsMobile] = useMobile();
  const [currentPage, togglePage] = useState(1);

  const lastPage = Math.ceil(topList.length / 4);

  return (
    <section id="partnerList">
      <h2>Partners</h2>

      <div id="partnerList_content">
        {currentPage !== 1 && (
          <div
            className="partnerList_arrow partnerList_arrow_left"
            onClick={() => move('backward')}
          >
            <LeftArrow />
          </div>
        )}

        <ul ref={list}>
          {isMobile
            ? props.list.map((partner, idx) => (
                <li key={idx} className="partnerList_item_mobile">
                  <Link
                    website={partner.website}
                    imageUrl={partner.imageUrl}
                    eventTrackingCodes={props.eventTrackingCodes}
                  />
                </li>
              ))
            : topList.map((partner, idx) => (
                <li key={idx} className="partnerList_item">
                  <div>
                    <Link
                      website={partner.website}
                      imageUrl={partner.imageUrl}
                      eventTrackingCodes={props.eventTrackingCodes}
                    />
                  </div>

                  {bottomList[idx] && (
                    <div>
                      <Link
                        website={bottomList[idx].website}
                        imageUrl={bottomList[idx].imageUrl}
                        eventTrackingCodes={props.eventTrackingCodes}
                      />
                    </div>
                  )}
                </li>
              ))}
        </ul>

        {currentPage !== lastPage && (
          <div
            className="partnerList_arrow partnerList_arrow_right"
            onClick={() => move('forward')}
          >
            <RightArrow />
          </div>
        )}

        <div className="partnerList_link">
          <a
            href="/partners"
            onClick={() =>
              props.eventTrackingCodes &&
              sendEvent(...props.eventTrackingCodes.all)
            }
          >
            Bekijk alle partners
          </a>
        </div>
      </div>
    </section>
  );

  function move(direction) {
    const isForward = direction === 'forward';

    const translateX = `${isForward ? `-${currentPage}` : `-${currentPage - 2}`}00%`;

    list.current.style.cssText = `
      transition-duration: .3s;
      transform: translateX(${translateX});
      transition-property: transform;
    `;

    togglePage((previousPage) =>
      isForward ? previousPage + 1 : previousPage - 1
    );
  }
}

function Link(props) {
  return (
    <a
      target="_blank"
      href={props.website}
      rel="noopener noreferrer"
      onClick={() =>
        props.eventTrackingCodes &&
        sendEvent(...props.eventTrackingCodes.partner)
      }
    >
      <img alt="partner-image" src={props.imageUrl} />
    </a>
  );
}
